

    <select (change)="changeLang($event)" class=" bg-transparent text-white border-0 language-select">
    <option class="text-black " *ngFor="let item of items" value="{{ item.value}}" [selected]="activeItem == item.value">{{ item.label }}</option>
    </select>
    <!-- <cx-icon [type]="iconTypes.CARET_DOWN" class="small"></cx-icon> -->


<!-- <p>sample</p> -->
